import { useQuery } from "@tanstack/react-query"
import { reverIntegrationQuery } from "modules/settings/lib/rever/reverIntegrationQuery"

export function useReverIntegrationQuery() {
  return useQuery(reverIntegrationQuery())
}
